import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import StaffAvailability from '../containers/StaffAvailability';

const UserProfile = (props) => {
  const {
    user: {
      attributes: {
        first_name: name,
        last_name: lastName,
        display_name: displayUsername,
      },
      id,
    },
    showUsername,
    color,
  } = props;

  const fullName = _.compact([name, lastName]).join(' ');
  const displayName = fullName || displayUsername;
  const usernameBox = showUsername ? <address style={{ color, fontSize: '0.9em' }}>{displayUsername}</address> : null;

  return (
    <div className="profile">
      <StaffAvailability userId={id} />
      <strong style={{ color }}>{displayName}</strong>
      {usernameBox}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    session: {
      user,
    },
  } = state;

  return {
    user,
  };
};

UserProfile.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
  }),
  showUsername: PropTypes.bool,
  color: PropTypes.string,
};

UserProfile.defaultProps = {
  color: '#444',
};

export default connect(mapStateToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/components/UserProfile.js